module.exports = __webpack_public_path__ + "448f2aaa315fa9dce7b2cf6ce31caed6.svg";